import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Toolbar = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
}));

export const Select = styled('select')(() => ({
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 500,
  color: protoColors.textPrimary,
  padding: '8px 12px',
  borderRadius: '10px',
  border: `1px solid ${protoColors.border}`,
  backgroundColor: protoColors.surface,
  cursor: 'pointer',
}));

export const SearchInput = styled('input')(() => ({
  fontFamily: 'inherit',
  fontSize: '13px',
  color: protoColors.textPrimary,
  padding: '8px 12px',
  borderRadius: '10px',
  border: `1px solid ${protoColors.border}`,
  backgroundColor: protoColors.surface,
  minWidth: '220px',
  '&::placeholder': {
    color: protoColors.textMuted,
  },
}));

export const Count = styled('span')(() => ({
  marginLeft: 'auto',
  fontSize: '13px',
  color: protoColors.textMuted,
}));

export const Layout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 380px',
  gap: '16px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const List = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  maxHeight: '620px',
  overflowY: 'auto',
  paddingRight: '4px',
}));

export const Row = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ selected }) => ({
  border: `1px solid ${selected ? protoColors.purple : protoColors.border}`,
  backgroundColor: selected ? protoColors.purpleSoft : protoColors.surface,
  borderRadius: '12px',
  padding: '12px 14px',
  cursor: 'pointer',
  textAlign: 'left',
  fontFamily: 'inherit',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  '&:hover': {
    borderColor: protoColors.purple,
  },
}));

export const RowTop = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
}));

export const Name = styled('span')(() => ({
  fontSize: '14px',
  fontWeight: 700,
  color: protoColors.textPrimary,
}));

export const Sub = styled('span')(() => ({
  fontSize: '12px',
  color: protoColors.textMuted,
}));

export const Badges = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '14px',
}));

export const Badge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  fontSize: '12.5px',
  color: protoColors.textMuted,
  '& strong': {
    color,
    fontWeight: 700,
  },
}));

export const PlanLabel = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: protoColors.textMuted,
  marginBottom: '6px',
}));

export const PlanTextarea = styled('textarea')(() => ({
  width: '100%',
  minHeight: '90px',
  resize: 'vertical',
  fontFamily: 'inherit',
  fontSize: '13px',
  color: protoColors.textPrimary,
  padding: '10px 12px',
  borderRadius: '10px',
  border: `1px solid ${protoColors.border}`,
  '&:focus': {
    outline: 'none',
    borderColor: protoColors.purple,
  },
}));

export const PlanCaption = styled(Typography)(() => ({
  fontSize: '11.5px',
  color: protoColors.textMuted,
  marginTop: '4px',
}));

export const SavePlanButton = styled('button')(() => ({
  marginTop: '8px',
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 600,
  color: protoColors.surface,
  backgroundColor: protoColors.purple,
  border: 'none',
  borderRadius: '10px',
  padding: '8px 16px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: protoColors.purpleDark,
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'default',
  },
}));
